import { useState, useCallback, useEffect } from "react";

type CanvasObject = any; // Define your canvas object type here

interface CanvasState {
  canvasObjects: CanvasObject[];
  // don't provide major state setters to the outside world.
  //
  // setCanvasObjects: React.Dispatch<React.SetStateAction<CanvasObject[]>>;
}

const useCanvasState = (
  fabricRef: React.RefObject<fabric.Canvas>
): CanvasState & {
  reorderCanvasObjects: (objects: CanvasObject[]) => void;
  syncShapeInStorage: (updatedObject: CanvasObject) => void;
  resetState: () => void;
  removeFromCanvas: (object: string) => void;
  loadCanvasDataComingFromJSONIntoState: (
    canvasObjects: CanvasObject[]
  ) => void;
} => {
  const [canvasObjects, setCanvasObjects] = useState<CanvasObject[]>([]);

  const syncShapeInStorage = (updatedObject: CanvasObject) => {
    console.log("syncShapeInStorage", updatedObject);
    if (!updatedObject) return;

    // If the object exists, update it; otherwise, add it to the state
    setCanvasObjects((prevObjects) => {
      const possibleExist = prevObjects.find(
        (object) => object?.objectId === updatedObject?.objectId
      );

      if (possibleExist) {
        return prevObjects.map((object) =>
          object?.objectId === updatedObject?.objectId ? updatedObject : object
        );
      } else {
        return [...prevObjects, updatedObject];
      }
    });
  };

  const resetState = () => {
    setCanvasObjects([]);
  };

  const removeFromCanvas = (objectId: string) => {
    setCanvasObjects((prevObjects) => {
      console.log("removeFromCanvas", objectId);
      const filtered = prevObjects.filter(
        (prevObject) => prevObject?.objectId !== objectId
      );
      return filtered;
    });
  };

  // when loading canvas data from server JSON.
  const loadCanvasDataComingFromJSONIntoState = (
    canvasObjects: CanvasObject[]
  ) => {
    setCanvasObjects(canvasObjects);
  };

  // for the layering control functionalities such as bring to front, send to back, etc.
  // we need to reorder the canvas objects in the state array. so, we need a function
  // to get the new order of the objects in the canvas, and update the state with the new order.
  // this is just a HOC function to provide cleaner code in the components.
  const reorderCanvasObjects = (objects: CanvasObject[]) => {
    setCanvasObjects(objects);
  };

  return {
    canvasObjects,
    reorderCanvasObjects,
    syncShapeInStorage,
    resetState,
    removeFromCanvas,
    loadCanvasDataComingFromJSONIntoState,
  };
};

export default useCanvasState;
